export default __webpack_public_path__ + "static/media/faq.8df0f784.png";